import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  openQuoteModal(event) {
    event.preventDefault()
    console.log('Opening quote creation modal from quotes page')
    document.dispatchEvent(new CustomEvent('open-quote-creation-modal'))
  }
}